import { Component, Input } from '@angular/core';
import { GebaeudeMasterDetailEntryMeta } from '../../../core/av-api';
import { LinkComponent, NavTarget } from '../link/link.component';
import { HistInfo } from '../../../core/gb-api';
import { KopfdatenelementComponent } from '../../widgets/kopfdatenelement/kopfdatenelement.component';
import { NgTemplateOutlet } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { GrundstuecknummerPipe } from '../../pipes/simple/grundstuecknummer.pipe';
import { OrderBySdrGrundstueckNummerPipe } from '../../pipes/order/order-by-sdr-grundstueck-nummer.pipe';

@Component({
  selector: 'cap-gebaeude-gehoert-zu-sdr',
  templateUrl: './gebaeude-gehoert-zu-sdr.component.html',
  styleUrls: ['./gebaeude-gehoert-zu-sdr.component.css'],
  imports: [
    KopfdatenelementComponent,
    NgTemplateOutlet,
    LinkComponent,
    TranslatePipe,
    GrundstuecknummerPipe,
    OrderBySdrGrundstueckNummerPipe
  ]
})
export class GebaeudeGehoertZuSdrComponent {
  navTargets = NavTarget;
  navTargetGrundstuecke = NavTarget.NAV_GRUNDSTUECK;

  @Input() histInfo: HistInfo;

  @Input()
  isKopfdatenElement = false;

  @Input()
  gebaeude: GebaeudeMasterDetailEntryMeta;

  @Input()
  navigateTo = NavTarget.NAV_GRUNDSTUECK;
  @Input()
  isIcp: boolean = false;

  constructor() {
    if (this.isIcp) {
      this.navTargetGrundstuecke = NavTarget.NAV_GRUNDSTUECK_ES;
    }
  }
}
